import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = () => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2802 5.43065C17.699 5.43065 18.0385 5.09115 18.0385 4.67236C18.0385 4.25356 17.699 3.91406 17.2802 3.91406C9.95755 3.91406 4 9.87253 4 17.1943C4 17.6131 4.33949 17.9526 4.75828 17.9526C5.17708 17.9526 5.51656 17.6131 5.51656 17.1943C5.51567 10.7083 10.7934 5.43065 17.2802 5.43065Z"
        fill="#A3A3A3"
      />
      <path
        d="M18.0347 8.71676C18.0347 8.29797 17.6952 7.9585 17.2764 7.9585C12.1823 7.9585 8.03711 12.1028 8.03711 17.1969C8.03711 17.6157 8.3766 17.9552 8.79539 17.9552C9.21418 17.9552 9.55367 17.6157 9.55367 17.1969C9.55367 12.9386 13.0181 9.47416 17.2773 9.47416C17.6952 9.47416 18.0347 9.13467 18.0347 8.71676Z"
        fill="#A3A3A3"
      />
      <path
        d="M18.0378 12.7583C18.0378 12.3395 17.6983 12 17.2795 12C14.4139 12 12.082 14.3319 12.082 17.1975C12.082 17.6163 12.4215 17.9558 12.8403 17.9558C13.2591 17.9558 13.5986 17.6163 13.5986 17.1975C13.5986 15.1677 15.2506 13.5157 17.2804 13.5157C17.6983 13.5157 18.0378 13.1771 18.0378 12.7583Z"
        fill="#A3A3A3"
      />
      <path
        d="M17.792 19.3789C18.7137 19.3789 19.4609 18.6317 19.4609 17.71C19.4609 16.7882 18.7137 16.041 17.792 16.041C16.8703 16.041 16.123 16.7882 16.123 17.71C16.123 18.6317 16.8703 19.3789 17.792 19.3789Z"
        fill="#A3A3A3"
      />
    </Svg>
  );
};

export default Icon;
